import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "line-item line-item-title"
};
const _hoisted_2 = {
  class: "line-item"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 2
};
const _hoisted_6 = {
  class: "line-item",
  style: {
    "color": "#909399"
  }
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  class: "tab-list"
};
const _hoisted_9 = {
  class: "tab-item"
};
const _hoisted_10 = {
  class: "line-item"
};
const _hoisted_11 = {
  class: "line-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_timeline_item = _resolveComponent("el-timeline-item");
  const _component_el_timeline = _resolveComponent("el-timeline");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_card = _resolveComponent("el-card");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_aside = _resolveComponent("el-aside");
  return _withDirectives((_openBlock(), _createBlock(_component_el_aside, {
    width: "300px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tabs, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.activeTab = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        label: "需求流程",
        name: "proc",
        class: "history-wrap"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          height: "100%"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_timeline, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processLogs, (proc, index) => {
              return _openBlock(), _createBlock(_component_el_timeline_item, {
                key: index,
                type: proc.type,
                timestamp: proc.optTime
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(proc.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(proc.items, (item, ind) => {
                  return _openBlock(), _createElementBlock("div", {
                    key: ind
                  }, [item && item.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
                    key: 0,
                    class: "line-item"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_col, {
                      span: 7
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(item[0]) + " : ", 1)]),
                      _: 2
                    }, 1024), _createVNode(_component_el_col, {
                      span: 17
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(item[1]), 1)]),
                      _: 2
                    }, 1024)]),
                    _: 2
                  }, 1024)) : _createCommentVNode("", true)]);
                }), 128))]),
                _: 2
              }, 1032, ["type", "timestamp"]);
            }), 128))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "参与者",
        name: "partner",
        class: "history-wrap"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          height: "100%"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnerLogs, (partner, index) => {
            return _openBlock(), _createBlock(_component_el_card, {
              class: "position-card",
              key: index
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createTextVNode(_toDisplayString(partner.userName) + " ", 1), partner.employeeNo || partner.telphone ? (_openBlock(), _createElementBlock("span", _hoisted_3, " ( ")) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(partner.employeeNo) + " ", 1), partner.employeeNo && partner.telphone ? (_openBlock(), _createElementBlock("span", _hoisted_4, " / ")) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(partner.telphone) + " ", 1), partner.employeeNo || partner.telphone ? (_openBlock(), _createElementBlock("span", _hoisted_5, " ) ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partner.roles, (role, ind) => {
                return _openBlock(), _createElementBlock("span", {
                  key: ind
                }, [_createTextVNode(_toDisplayString(role.roleName) + " ", 1), ind != partner.roles.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_7, " / ")) : _createCommentVNode("", true)]);
              }), 128))])]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "需求日志",
        name: "demand",
        class: "history-wrap"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          height: "100%"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_timeline, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.demandLogs, (demand, index) => {
              return _openBlock(), _createBlock(_component_el_timeline_item, {
                key: index,
                type: "primary",
                size: demand.size,
                timestamp: demand.optTime
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_10, _toDisplayString(demand.optContent) + "    " + _toDisplayString(demand.opterName), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(demand.optRemark), 1)]),
                _: 2
              }, 1032, ["size", "timestamp"]);
            }), 128))]),
            _: 1
          })])])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue"])]),
    _: 1
  }, 512)), [[_vShow, _ctx.$route.path === '/my-needs/detail']]);
}